var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.143 18.857h-1.655l-1.898-1.761a6.857 6.857 0 1 1 1.543-2.032l-1.02-.844a5.572 5.572 0 1 0-1.47 1.997l-.948-.883a4.286 4.286 0 1 1 .866-.947zM12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQmall);
export default __webpack_public_path__ + "static/media/qmall.10be7d4b91832b71bf19a7b7d924a652.svg";
export { ForwardRef as ReactComponent };